
import { monthlyFootnoteFormatter } from 'app/components/questions/base'
import { SingleQuestion } from 'app/components/questions/single'
import { genericChangeCTA } from 'app/containers/PipelineSection/Expenses'
import * as React from 'react'

const MortgageQuestionsGroup = () => (
  <SingleQuestion
    header="Mortgage/Rent"
    icon="fa fa-fw fa-home"
    headerDescription="In this section, you'll be entering your mortgage or rent"
    question={{
      placeholder: 'Enter your current monthly mortgage or rent',
      name: 'expenses.mortgage.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'monthly',
    }}
    option={{
      callToAction: genericChangeCTA,
      question: {
        placeholder: 'Enter your monthly mortgage or rent during retirement',
        name: 'expenses.mortgage.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'monthly',
      }
    }} />
)

const PropertyTaxesQuestionsGroup = () => (
  <SingleQuestion
    header="Property Taxes"
    icon="fa fa-fw fa-usd"
    headerDescription="In this section, you'll be entering your property taxes"
    question={{
      placeholder: 'Enter your current annual property taxes',
      name: 'expenses.propertyTaxes.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'yearly',
    }}
    itemFootnoteFormatter={monthlyFootnoteFormatter}
    option={{
      callToAction: genericChangeCTA,
      question: {
        placeholder: 'Enter your annual property taxes during retirement',
        name: 'expenses.propertyTaxes.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'yearly',
      },
      itemFootnoteFormatter: monthlyFootnoteFormatter
    }} />
)

const HomeInsuranceQuestionsGroup = () => (
  <SingleQuestion
    header="Home Insurance"
    icon="fa fa-fw fa-life-ring"
    headerDescription="In this section, you'll be entering your home insurance"
    question={{
      placeholder: 'Enter your current monthly home insurance',
      name: 'expenses.homeInsurance.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'monthly',
    }}
    option={{
      callToAction: genericChangeCTA,
      question: {
        placeholder: 'Enter your monthly home insurance during retirement',
        name: 'expenses.homeInsurance.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'monthly',
      }
    }} />
)

const HomeMaintanenceQuestionsGroup = () => (
  <SingleQuestion
    header="Home Maintenance"
    icon="fa fa-fw fa-wrench"
    headerDescription="In this section, you'll be entering your home maintenance"
    question={{
      placeholder: 'Enter your current annual home maintenance',
      name: 'expenses.homeMaintenance.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'yearly',
    }}
    itemFootnoteFormatter={monthlyFootnoteFormatter}
    option={{
      callToAction: genericChangeCTA,
      question: {
        placeholder: 'Enter your home maintenance during retirement',
        name: 'expenses.homeMaintenance.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'yearly',
      },
      itemFootnoteFormatter: monthlyFootnoteFormatter
    }} />
)

const UtilitiesQuestionsGroup = () => (
  <SingleQuestion
    header="Utilities"
    icon="fa fa-fw fa-cog"
    headerDescription="In this section, you'll be entering your utilities"
    question={{
      placeholder: 'Enter your current monthly utilities',
      name: 'expenses.homeUtilities.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'monthly',
    }}
    option={{
      callToAction: genericChangeCTA,
      question: {
        placeholder: 'Enter your utilities during retirement',
        name: 'expenses.homeUtilities.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'monthly',
      }
    }} />
)

export {
  MortgageQuestionsGroup,
  PropertyTaxesQuestionsGroup,
  HomeInsuranceQuestionsGroup,
  HomeMaintanenceQuestionsGroup,
  UtilitiesQuestionsGroup,
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Expenses/Home/index.tsx